import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_black.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3d25f4a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-sidebar-container" }
const _hoisted_2 = { class: "top-sidebar" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "flex fl-1 fl-jc-end m-r-20"
}
const _hoisted_6 = { class: "user-info flex flex-col" }
const _hoisted_7 = { class: "user-name" }
const _hoisted_8 = {
  key: 0,
  class: "user-agency"
}
const _hoisted_9 = {
  key: 0,
  class: "user-panel"
}
const _hoisted_10 = { class: "user-name" }
const _hoisted_11 = {
  key: 0,
  class: "user-agency m-t-4"
}
const _hoisted_12 = { class: "user-email m-t-4" }
const _hoisted_13 = {
  key: 1,
  class: "user-department m-t-12"
}
const _hoisted_14 = { class: "user-panel-actions" }

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";

import { useAuthStore } from "@/store/auth/login";
import { useOrganizationsBaseDictionaryStore } from "@/store/catalog_data/organization_base";

import Avatar from "primevue/avatar";
import Button from "primevue/button";
import OverlayPanel from "primevue/overlaypanel";
import Dropdown from "primevue/dropdown";

import { getUserName } from "@/services/utils/Names";
import { getCurrentDomain } from "@/services/utils/Domain";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopLogoSidebar',
  setup(__props) {

const domain = getCurrentDomain();
const router = useRouter();

const store = useAuthStore();
const orgStore = useOrganizationsBaseDictionaryStore();

const op = ref();
const isLoading = ref(false);
const org = ref(null);

const isOrgMayChanged = computed(() => {
  return !store.isDeniedForPermissions([
    "external_agency:read",
    "external_agency:edit",
  ]);
});

onMounted(() => {
  if (!store.user && store.isLoggedIn) {
    store.getUserInfo();
  }

  isLoading.value = true;

  orgStore.getItems().then(() => {
    store.getOrganizationByUserTenant().then((orgValue: any) => {
      if (orgValue) {
        org.value = orgValue;
      }
      isLoading.value = false;
    });
  });
});

const toggle = (event: any) => {
  op.value.toggle(event);
};

const onChangeOrg = (event: any) => {
  store.changeTenant(event.value.tenant);
};

const goToPersonalAccount = () => {
  op.value.hide();
  router.push({ name: "personalAccount" });
};

function logout() {
  store.logout().then(() => {
    location.reload();
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(domain).includes('dvgroup.com'))
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      (isOrgMayChanged.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(Dropdown), {
              modelValue: org.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((org).value = $event)),
              class: "org-dropdown",
              options: _unref(orgStore).itemList,
              loading: isLoading.value,
              filter: "",
              panelClass: "org-drop",
              optionLabel: "name",
              onChange: onChangeOrg,
              placeholder: "Загрузка..."
            }, null, 8, ["modelValue", "options", "loading"])
          ]))
        : _createCommentVNode("", true),
      (_unref(store).user)
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "user",
            onClick: toggle
          }, [
            _createVNode(_unref(Avatar), {
              icon: "pi pi-user",
              class: "dv-avatar",
              shape: "circle"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getUserName)(_unref(store).user)), 1),
              (_unref(store).user.role)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(store).user.role.department.organization.name), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op,
      showCloseIcon: ""
    }, {
      default: _withCtx(() => [
        (_unref(store).user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getUserName)(_unref(store).user)), 1),
              (_unref(store).user.role)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(store).user.role.department.organization.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(store).user.email), 1),
              (_unref(store).user.role)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(store).user.role.department.name) + " / " + _toDisplayString(_unref(store).user.role.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(Button), {
                  label: "Личный кабинет",
                  class: "panel-link-button profile-button",
                  icon: "pi pi-id-card",
                  onClick: goToPersonalAccount
                }),
                _createVNode(_unref(Button), {
                  label: "Выйти из аккаунта",
                  class: "panel-link-button logout-button",
                  icon: "pi pi-sign-out",
                  onClick: logout
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512)
  ]))
}
}

})